import { useRouter } from 'core/hooks/useRouter';
import { isLicenseDeniedResponse } from 'core/utils/authErrors';
import { useTranslation } from 'react-i18next';
import { useToasts } from 'react-toast-notifications';

import type { HttpErrorResponse } from 'core/utils/authErrors';

type UseCourseAccessDenied = {
  leaveDeniedCourse: (errorResponse?: HttpErrorResponse) => void;
};

const HOME_PATH = '/home';
// Id fijo porque unas treinta vistas montan useCourse a la vez y axios deduplica la petición: todas
// reciben el mismo 403. react-toast-notifications 2.4.0 descarta un addToast cuyo id ya está en
// pantalla, así que el usuario ve un solo aviso en vez de uno por vista.
const COURSE_ACCESS_DENIED_TOAST_ID = 'course-access-denied';

/** Avisa de que el usuario ha perdido el acceso al curso (licencia o permiso) y lo devuelve a inicio. */
function useCourseAccessDenied(): UseCourseAccessDenied {
  const { t } = useTranslation();
  const { addToast } = useToasts();
  const router = useRouter();

  function leaveDeniedCourse(errorResponse?: HttpErrorResponse): void {
    // Namespace `classroom`, aunque en es/en/pt viva en courses.json: `courses:` no existe y
    // devolvía la clave en inglés en todos los idiomas.
    const messageKey = isLicenseDeniedResponse(errorResponse) ? 'classroom:No active license' : 'classroom:No access to this course';

    addToast(t(messageKey), { appearance: 'error', autoDismiss: true, id: COURSE_ACCESS_DENIED_TOAST_ID });
    router.history.push(HOME_PATH);
  }

  return { leaveDeniedCourse };
}

export default useCourseAccessDenied;
